export default {
  name: 'register-mixin',

  methods: {
    toLogin() {
      this.$router.push({ name: 'login' });
    },

    backToRegister() {
      window.location.href = 'https://www.chance4talents.de/wer-bist-du';
    },
  },
};
